import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-slate-300 pt-20 pb-10 border-t-4 border-accent" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6" data-id="element-17">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-18">
          {/* Brand */}
          <div className="flex flex-col gap-6" data-id="element-19">
            <Link to="/" className="flex items-center gap-3 group shrink-0" data-id="element-20">
              <video src="https://cdn.magicpatterns.com/uploads/7WxQuepNXeVvAcNAXbfhWT/kling_20260618_VIDEO_Create_a_p_561_0.mp4" autoPlay loop muted playsInline className="h-16 w-auto object-contain" data-id="element-21" />
              <div className="flex flex-col leading-none" data-id="element-22">
                <span className="font-display font-bold text-base text-white tracking-tight" data-id="element-23">
                  THE ELECTRICAL
                </span>
                <span className="font-display font-bold text-base text-white tracking-tight" data-id="element-24">
                  PROFESSIONALS INC
                </span>
              </div>
            </Link>
            <p className="text-sm leading-relaxed" data-id="element-25">
              Powering homes, businesses, and communities with confidence. Safe,
              dependable, and high-quality electrical solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-26">
            <h3 className="text-yellow-400 font-display font-semibold text-lg mb-6 uppercase tracking-wider" data-id="element-27">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-28">
              <li data-id="element-29">
                <Link to="/" className="hover:text-accent transition-colors" data-id="element-30">
                  Home
                </Link>
              </li>
              <li data-id="element-31">
                <Link to="/about" className="hover:text-accent transition-colors" data-id="element-32">
                  About Us
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/gallery" className="hover:text-accent transition-colors" data-id="element-34">
                  Project Gallery
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/financing" className="hover:text-accent transition-colors" data-id="element-36">
                  Financing
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/quote" className="hover:text-accent transition-colors" data-id="element-38">
                  Request a Free Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-39">
            <h3 className="text-yellow-400 font-display font-semibold text-lg mb-6 uppercase tracking-wider" data-id="element-40">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-41">
              <li className="flex items-start gap-3" data-id="element-42">
                <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-43" />
                <a href="tel:4075040596" className="hover:text-white transition-colors" data-id="element-44">
                  (407) 504-0596
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-45">
                <Mail className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-46" />
                <a href="mailto:Info@theepinc.com" className="hover:text-white transition-colors" data-id="element-47">
                  Info@theepinc.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-48">
                <Clock className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-49" />
                <div className="text-sm" data-id="element-50">
                  <p data-id="element-51">Mon-Fri: 9:00 AM - 5:00 PM</p>
                  <p data-id="element-52">Sat-Sun: By Appointment</p>
                </div>
              </li>
            </ul>
            <Link to="/quote" className="mt-6 inline-block bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-sm text-sm font-semibold transition-colors" data-id="element-53">
              Request a Free Quote
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500" data-id="element-54">
          <p data-id="element-55">
            Copyright © {new Date().getFullYear()} The Electrical Professionals
            Inc. All rights reserved. | Licensed & Insured Electrical Contractor
          </p>
          <div className="flex gap-6" data-id="element-56">
            <span className="hover:text-slate-300 cursor-pointer transition-colors" data-id="element-57">
              Privacy Policy
            </span>
            <span className="hover:text-slate-300 cursor-pointer transition-colors" data-id="element-58">
              Terms of Service
            </span>
          </div>
        </div>

        <div className="pt-6 text-center" data-id="element-59">
          <a href="https://trippinwithmandy.com" target="_blank" rel="noopener noreferrer" className="text-[11px] text-slate-600 hover:text-slate-400 transition-colors" data-id="element-60">
            Made with a whole lot of grit by Trippin' With Mandy™ LLC
          </a>
        </div>
      </div>
    </footer>;
}